// extracted by mini-css-extract-plugin
export var questionBox = "_97-0";